export default __webpack_public_path__ + "static/media/13.fa3579fc.PNG";